/**
 * 分镜检查器 - 「关键帧」tab
 *
 * 候选网格 + 生成 / 导入 / 锁定按钮
 * 网格在本 tab 占满高度，方便挑图。
 */

import { Sparkles } from 'lucide-react';
import type { DirectorImageJob } from '../../../services/directorApi';
import { KeyframeCandidatesGrid } from '../KeyframeCandidatesGrid';

interface Props {
  candidates: DirectorImageJob[];
  lockedJobId: string | null;
  videoActive: boolean;
  hasMore: boolean;
  expandKeyframes: boolean;
  setExpandKeyframes: (v: boolean) => void;
  onGenerateNew: () => void;
  onLock: (imageJobId: string) => void;
  onUnlock: () => void;
  onDelete: (imageJobId: string) => void;
  onRequestImport?: () => void;
}

export function ShotKeyframeTab({
  candidates,
  lockedJobId,
  videoActive,
  hasMore,
  expandKeyframes,
  setExpandKeyframes,
  onGenerateNew,
  onLock,
  onUnlock,
  onDelete,
  onRequestImport,
}: Props) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.18em] text-slate-500">
          <Sparkles className="h-3 w-3" /> 关键帧候选（{candidates.length}）
        </h4>
        {onRequestImport && !videoActive && (
          <button
            type="button"
            onClick={onRequestImport}
            className="text-[11px] font-medium text-sky-600 transition hover:text-sky-700"
            title="从作品库选一张作为候选"
          >
            从作品库导入
          </button>
        )}
      </div>

      <KeyframeCandidatesGrid
        candidates={candidates}
        lockedJobId={lockedJobId}
        lockDisabled={videoActive}
        onGenerateNew={onGenerateNew}
        onLock={onLock}
        onUnlock={onUnlock}
        onDelete={onDelete}
      />

      {(hasMore || expandKeyframes) && (
        <div className="text-center">
          <button
            type="button"
            onClick={() => setExpandKeyframes(!expandKeyframes)}
            className="text-[11px] font-medium text-sky-600 transition hover:text-sky-700"
          >
            {expandKeyframes ? '收起候选' : '查看更多候选'}
          </button>
        </div>
      )}
    </div>
  );
}
